module.exports = __webpack_public_path__ + "img/add-task-celeb-dialog.2a48b8fc.png";